import type { RoleResponse } from "~types/role";
import type { SeasonRoster, SeasonRosterResources, SeasonRosterResponse } from "~types/seasonRoster";

export const transformSeasonRoster = (response: SeasonRosterResponse, rolesResponse?: RoleResponse) => {
  const resources: SeasonRosterResources | undefined = response?.includes?.resources;
  const captains = rolesResponse?.data.map((role) => ({
    entityId: role.entityId,
    seasonId: role.seasonId,
    role: role.role,
    roleId: role.roleId,
    personId: role.personId,
  }));
  return (
    response?.data?.map((item: SeasonRoster) => {
      const captain = captains?.find((captain) => captain.entityId === item.entityId && captain.personId === item.personId);
      return {
        ...item,
        entity: resources?.[item.entity?.resourceType ?? ""]?.[item.entity?.id ?? ""],
        person: resources?.[item.person?.resourceType ?? ""]?.[item.person?.id ?? ""],
        isCaptain: !!captain,
        captainRoleId: captain?.roleId,
      };
    }) || []
  );
};
